import { MeasureDataTableFilters } from "store/types";
import { useContextSelector } from "use-context-selector";

import { IStore, StoreContext } from "../../store-context";

export const useMonitoringDataFilters = (): MeasureDataTableFilters =>
  useContextSelector(StoreContext, (state: IStore) => state.dealModule.measureDataTableFilters);
